import axios from "axios";

interface IParams {
  baseUrl: string;
  tokenKey: string;
  refreshKey: string;
  getFunction(key: string): Promise<string | boolean | undefined | null>;
  setFunction(key: string, value: string): Promise<void>;
  deleteFunction(key: string): Promise<void>;
}

interface Jwt extends IParams {
  refreshToken(tempToken?: string, tempRefreshToken?: string): Promise<boolean>;
}

class Jwt {
  constructor(params: IParams) {
    this.baseUrl = params.baseUrl;
    this.tokenKey = params.tokenKey;
    this.refreshKey = params.refreshKey;
    this.getFunction = params.getFunction;
    this.setFunction = params.setFunction;
    this.deleteFunction = params.deleteFunction;
  }

  async refreshToken(tempToken?: string, tempRefreshToken?: string) {
    try {
      const currentRefreshToken = await this.getFunction(this.refreshKey) || tempRefreshToken;
      const currentToken = await this.getFunction(this.tokenKey) || tempToken;

      const res = await axios.post(`auth/refresh-token`, {
        refreshToken: currentRefreshToken,
      }, {
        baseURL: this.baseUrl,
        headers: {
          'credential': currentToken
        }
      });
  
      const { accessToken, refreshToken } = res.data.data;
  
      await this.setFunction(this.tokenKey, accessToken);
      await this.setFunction(this.refreshKey, refreshToken);
  
      return accessToken;
    } catch (refreshError) {
      await this.deleteFunction(this.tokenKey);
      await this.deleteFunction(this.refreshKey);

      return null;
    }
  }
}

export default Jwt;